import { useState, useEffect, useRef } from "react";
import { IoIosSearch } from "react-icons/io";
import { LuPlus } from "react-icons/lu";
import { FaEye, FaEdit, FaTrash } from "react-icons/fa"; // Add icons for view, edit, remove
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosinstance";
import "./Table.css";

import { CiMenuBurger } from "react-icons/ci";

function RecordPayment({ isSidebarExpanded }) {
  const [admins, setAdmins] = useState([]); // State to hold admins data
  const navigate = useNavigate();
  const [isSortPopup, setIsSortPopup] = useState(false);
  const containerRef = useRef(null);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });

  const handleSort = (key) => {
    // If the same column is clicked again, toggle the direction.
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }

    const sortedClients = [...admins].sort((a, b) => {
      const aValue =
        key === "contact_details" && a.contact_details?.length
          ? a.contact_details[0].contact_name.toLowerCase()
          : a[key];

      const bValue =
        key === "contact_details" && b.contact_details?.length
          ? b.contact_details[0].contact_name.toLowerCase()
          : b[key];

      // Compare the values and return the sort order.
      if (aValue < bValue) return direction === "asc" ? -1 : 1;
      if (aValue > bValue) return direction === "asc" ? 1 : -1;
      return 0;
    });

    // Update the sort configuration and set the sorted clients
    setSortConfig({ key, direction });
    setAdmins(sortedClients);
  };

  useEffect(() => {
    const fetchAdmins = async () => {
      try {
        const response = await axiosInstance.get("/api/get_all_admins");

        if (response.status === 200) {
          setAdmins(response.data.data);
        } else {
          console.error("Failed to fetch admins");
        }
      } catch (error) {
        console.error("Error fetching admins:", error);
      }
    };

    fetchAdmins();
  }, []);
  // Empty dependency array to fetch data on mount

  const handleCaAdmin = () => {
    navigate("/CA-Admin-form");
  };
  const handleSortpopup = () => {
    setIsSortPopup(!isSortPopup);
  };
  const handleAdminEdit = (admin_id) => {
    navigate(`/edit-Admin/${admin_id}`);
  };

  return (
    <div
      className={`table-container ${
        isSidebarExpanded ? "expanded" : "collapsed"
      }`}
    >
      <div className="table-container-content">
        <div className="table-header">
          <div className="table-header-content">
            <div className="table-left-side">
              <h2 className="jost-bold">All Admins</h2>
            </div>
            <div className="table-right-side">
              <div className="new-button" onClick={() => handleCaAdmin()}>
                <span className="new-icon">
                  <LuPlus />
                </span>
                <span>New</span>
              </div>
              <button className="sort-button" onClick={handleSortpopup}>
                <CiMenuBurger className="sort-icon" />
              </button>
              {isSortPopup && (
                <div className="sort-popup-container" ref={containerRef}>
                  <div className="sort-popup-header">
                    <span className="sort-title">Sort By</span>
                  </div>
                  <div className="sort-popup-content">
                    <button
                      className="sort-button sort-button-options"
                      onClick={() => handleSort("Admin_name")}
                    >
                      Name
                    </button>
                    <button
                      className="sort-button sort-button-options"
                      onClick={() => handleSort("Firm_name")}
                    >
                      Firm Name
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="data-list-body">
          <div className="data-list-scroll-body">
            <div className="data-list-table">
              <table className="table multilevel-data">
                <thead>
                  <tr className="table-row">
                    <th>Se. No</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone No</th>
                    <th>Firm Name</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Displaying the fetched data in the table */}
                  {admins.map((admin, index) => (
                    <tr className="hoverable-row" key={admin.Admin_id}>
                      <td className="center-align">{index + 1}</td>
                      <td className="center-align">{admin.Admin_name}</td>
                      <td className="center-align">{admin.Admin_Email}</td>
                      <td className="center-align">{admin.Contact_Number}</td>
                      <td className="center-align">{admin.Firm_name}</td>
                      <td className="center-align">
                        <div className="action-btn">
                          {/* Action buttons with icons */}
                          <button
                            className="action-button"
                            onClick={() => handleAdminEdit(admin.Admin_id)}
                          >
                            <FaEdit /> {/* Edit icon */}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecordPayment;
